export default __webpack_public_path__ + "static/media/Ficha_Agrosatadapt-1.bb235bc0.png";